module.exports = "/virtual-football-league/img/amblems/left/logos/Barcelona.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Barcelona.png
// module id = 2055
// module chunks = 4